/**
 * Product page: defer heavy MP4 loads until sections are near the viewport.
 * Relies on video[data-lazy-src] and/or source[data-lazy-src] without src.
 */
(function () {
  function hydrateLazyVideo(el) {
    if (!el || el.dataset.lazyLoaded === "1") return false;
    var directSrc = el.getAttribute("data-lazy-src");
    var lazySources = el.querySelectorAll("source[data-lazy-src]");
    if (!directSrc && !lazySources.length) return false;

    if (directSrc) {
      var s = el.querySelector("source");
      if (!s) {
        el.insertAdjacentHTML("beforeend", '<source src="' + directSrc + '" type="video/mp4">');
      } else if (!s.getAttribute("src")) {
        s.setAttribute("src", directSrc);
      }
      el.removeAttribute("data-lazy-src");
    }

    lazySources.forEach(function (srcEl) {
      var u = srcEl.getAttribute("data-lazy-src");
      if (u) {
        srcEl.setAttribute("src", u);
        srcEl.removeAttribute("data-lazy-src");
      }
    });

    el.dataset.lazyLoaded = "1";
    delete el.dataset.responsiveSourcesBackup;
    delete el.dataset.responsiveAppliedUrl;
    if (typeof window.applyResponsiveVideoToElement === "function") {
      window.applyResponsiveVideoToElement(el);
    }
    if (!el.dataset.responsiveAppliedUrl) {
      el.load();
      if (typeof window.primeVideoElement === "function") {
        window.primeVideoElement(el);
      } else if (el.autoplay) {
        var p = el.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    return true;
  }

  window.hydrateLazyVideo = hydrateLazyVideo;

  if (!("IntersectionObserver" in window)) {
    document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll("video").forEach(function (v) {
        if (v.hasAttribute("data-lazy-src") || v.querySelector("source[data-lazy-src]")) {
          hydrateLazyVideo(v);
        }
      });
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var v = e.target;
        io.unobserve(v);
        hydrateLazyVideo(v);
      });
    },
    { rootMargin: "380px 0px", threshold: 0.01 }
  );

  function observeLazyVideos() {
    document.querySelectorAll("video").forEach(function (v) {
      if (!v.hasAttribute("data-lazy-src") && !v.querySelector("source[data-lazy-src]")) return;
      io.observe(v);
    });
  }

  function bootLazyVideos() {
    observeLazyVideos();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootLazyVideos);
  } else {
    bootLazyVideos();
  }

  document.addEventListener(
    "mouseenter",
    function (ev) {
      var card = ev.target.closest && ev.target.closest(".testimonial-cards");
      if (!card) return;
      var v = card.querySelector("video");
      if (
        v &&
        (v.hasAttribute("data-lazy-src") || v.querySelector("source[data-lazy-src]"))
      ) {
        hydrateLazyVideo(v);
      }
    },
    true
  );
})();
